import React from 'react'

/**
 * the React context, so that information can be consumed by every components
 * in the application.
 */
const TrolleyContext = React.createContext()

export default TrolleyContext
